import { render, staticRenderFns } from "./wechatPicture.vue?vue&type=template&id=fd1b74fc"
import script from "./wechatPicture.vue?vue&type=script&lang=js"
export * from "./wechatPicture.vue?vue&type=script&lang=js"
import style0 from "./wechatPicture.vue?vue&type=style&index=0&id=fd1b74fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports